import Vue from 'vue'
import ElementUI from 'element-ui';
import App from './App.vue'
import router from './router'
import store from './store'
import {
  getDicts,
  getUpDicts,
  getJcDicts
} from "@/api/index";
import {
  parseTime
} from '@/utils/common'
import Pagination from "@/components/pagination/pagination.vue";
Vue.prototype.parseTime = parseTime
import './permission'
import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/styles/index.scss'
// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.prototype.msgSuccess = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "success"
  });
}
Vue.prototype.msgError = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "error"
  });
}
Vue.prototype.msgwarning = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: "warning"
  });
}
Vue.prototype.getDicts = getDicts
Vue.prototype.getUpDicts = getUpDicts
Vue.prototype.getJcDicts = getJcDicts
Vue.use(ElementUI);
// //禁止打开f12和检查
// document.addEventListener('keydown', (e) => {
//   if (e.keyCode === 123) {
//     e.preventDefault();
//   }
//   if (e.ctrlKey && e.shiftKey && [73, 74, 67].includes(e.keyCode)) {
//     e.preventDefault();
//   }
//   if (e.ctrlKey && e.keyCode === 85) {
//     e.preventDefault();
//   }
// });
// document.addEventListener('contextmenu', (e) => e.preventDefault())

// 全局注册自定义指令，用于解决el-radio使用的报错
Vue.directive('removeAriaHidden', {
  bind(el, binding) {
    let ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden');
    });
  }
});



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')